import type * as React from "react"

import { lazyDefaultComponent, lazyNamedComponent } from "@/app/router/route-helpers"

type DefaultRouteModule = {
  default: React.ComponentType<unknown>
}

type NamedRouteModule = Record<string, unknown>

const pageModules = import.meta.glob<DefaultRouteModule>("../**/page.tsx")
const namedRouteModules: Record<string, () => Promise<NamedRouteModule>> = {
  ...import.meta.glob<NamedRouteModule>([
    "./auth-layout-route.tsx",
    "./not-found-route.tsx",
    "./members-layout-route.tsx",
    "./my-branch-layout-route.tsx",
    "./settings-layout-route.tsx",
    "./reports-layout-route.tsx",
    "./finance-settings-layout-route.tsx",
    "./finance-accounts-funds-layout-route.tsx",
    "./global-finance-layout-route.tsx",
    "./system-settings-layout-route.tsx",
    "./organization-settings-layout-route.tsx",
    "./admin-layout-route.tsx",
  ]),
  ...import.meta.glob<NamedRouteModule>("../../features/**/admin-route-layouts.tsx"),
}

function getPageImporter(modulePath: string): () => Promise<DefaultRouteModule> {
  const importer = pageModules[modulePath]

  if (!importer) {
    throw new Error(`Unknown route page module: ${modulePath}`)
  }

  return importer
}

function getNamedRouteImporter(modulePath: string): () => Promise<NamedRouteModule> {
  const importer = namedRouteModules[modulePath]

  if (!importer) {
    throw new Error(`Unknown named route module: ${modulePath}`)
  }

  return importer
}

export function lazyPage(modulePath: string) {
  return lazyDefaultComponent(getPageImporter(modulePath))
}

export function lazyNamedRouteModule(modulePath: string, exportName: string) {
  return lazyNamedComponent(getNamedRouteImporter(modulePath), exportName)
}
